import { render, staticRenderFns } from "./lab-card-equipment.vue?vue&type=template&id=3146f2fe&"
import script from "./lab-card-equipment.vue?vue&type=script&lang=js&"
export * from "./lab-card-equipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3146f2fe')) {
      api.createRecord('3146f2fe', component.options)
    } else {
      api.reload('3146f2fe', component.options)
    }
    module.hot.accept("./lab-card-equipment.vue?vue&type=template&id=3146f2fe&", function () {
      api.rerender('3146f2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/labs/lab-card-equipment.vue"
export default component.exports